/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Balcony_AreaInputs */

const cs_form_balcony_area = /** @type {(inputs: Form_Balcony_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha balkonu (m²)`)
};

const en_form_balcony_area = /** @type {(inputs: Form_Balcony_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balcony area (m²)`)
};

/**
* | output |
* | --- |
* | "Balcony area (m²)" |
*
* @param {Form_Balcony_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_balcony_area = /** @type {((inputs?: Form_Balcony_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Balcony_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_balcony_area(inputs)
	return cs_form_balcony_area(inputs)
});